export const GET_RECENT_LISTING = 'usedCarDealer/GET_RECENT_LISTING';
export const GET_WISHLIST = 'usedCarDealer/GET_WISHLIST';
export const GET_HISTORY = 'usedCarDealer/GET_HISTORY';
export const GET_TRENDING = 'usedCarDealer/GET_TRENDING';
export const GET_WISHLIST_START = 'usedCarDealer/GET_WISHLIST_START';
// export const GET_WISHLIST_REQUEST = 'usedCarDealer/GET_WISHLIST_REQUEST';
// export const GET_WISHLIST_SUCCESS = 'usedCarDealer/GET_WISHLIST_SUCCESS';
// export const GET_WISHLIST_FAILURE = 'usedCarDealer/GET_WISHLIST_FAILURE';
export const GET_RECOMMENDED = 'usedCarDealer/GET_RECOMMENDATION';
export const GET_EXPLORE_MARKETPLACE = 'usedCarDealer/GET_EXPLORE_MARKETPLACE';
// export const UPDATE_LOCATION = 'usedCarDealer/UPDATE_LOCATION';
export const UPDATE_CITY_LIST = 'usedCarDealer/UPDATE_CITY_LIST';
export const UPDATE_SIMILAR_BY_PRICE = 'usedCarDealer/UPDATE_SIMILAR_BY_PRICE';
export const GET_FEEDBACK_DATA = 'usedCarDealer/GET_FEEDBACK_DATA';
export const UPDATE_BRAND_LIST = 'usedCarDealer/UPDATE_BRAND_LIST';
export const UPDATE_MAPPED_LOCATION = 'usedCarDealer/UPDATE_MAPPED_LOCATION';
export const UPDATE_COORDINATES = 'usedCarDealer/UPDATE_COORDINATES';
export const UPDATE_NEARYBY_CITIES = 'usedCarDealer/UPDATE_NEARYBY_CITIES';
